import { Panel, PanelGroup } from 'react-resizable-panels';

import { cn } from '@/utils/tailwind';

import { PlaygroundColumnDivider } from './PlaygroundLayout';

// The base layout of the playground - UI only. Do not add useEffect or any other type of logic here.
// If you make any changes, you must check that it works in the normal playground AND the evaluator playground.
export const PlaygroundBody = ({
  orientation,
  stackVertically,
  hidePromptSection,
  layout,
  promptsSection,
  inputAndOutputSection,
}: {
  orientation: 'vertical' | 'horizontal';
  stackVertically: boolean;
  hidePromptSection: boolean;
  layout: {
    input: { default: number; min: number };
    output: { default: number; min: number };
  };
  promptsSection: React.ReactNode;
  inputAndOutputSection: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        'relative flex h-full w-full flex-row justify-stretch border-secondary'
      )}
    >
      <PanelGroup
        direction={orientation}
        className={cn(stackVertically ? 'w-full' : 'h-full')}
      >
        <Panel
          defaultSize={hidePromptSection ? 5 : layout.input.default}
          style={{
            overflowY: 'auto',
            minHeight: hidePromptSection ? '40px' : undefined,
            maxHeight: hidePromptSection ? '40px' : undefined,
            height: hidePromptSection ? '40px' : undefined,
          }}
          minSize={hidePromptSection ? 5 : layout.input.min}
          maxSize={hidePromptSection ? 5 : undefined}
        >
          {promptsSection}
        </Panel>
        {!hidePromptSection && (
          <PlaygroundColumnDivider orientation={orientation} />
        )}
        <Panel
          defaultSize={layout.output.default}
          style={{ overflowY: 'auto' }}
          className={cn('border-primary', !stackVertically && 'border-l')}
          minSize={layout.output.min}
        >
          {inputAndOutputSection}
        </Panel>
      </PanelGroup>
    </div>
  );
};
